var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.note !== null)?[(_vm.author === 'system')?_c('note-system',{attrs:{"name":_vm.note}}):_c('note-simple',{attrs:{"name":_vm.note}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }